import { FInter, Colors, DropdownListItem } from '@brg/ui';
import { RectangularButtonFilled, RectangularButtonHollow } from 'shared/components/buttons';
import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { ExploreButtonFilled, ExploreButtonHollow } from '../explore/styles';
import { LayoutConst } from 'core';
import ReactTooltip from 'react-tooltip';
import { Input } from '@brg/input';

const CreateBooksBtn = styled.div<{ visible: boolean }>`
    font-style: Inter;
    color: #909090;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

`;

export const CreateBtn = styled(RectangularButtonFilled)<{ isGreenBG?: boolean, isLMS?: boolean }>`
    height: 46px !important;
    max-height: 46px !important;
    max-width: 146px;
    width: 145px;

    ${({isLMS}) => isLMS ? css`
        border: 1px solid #B6B6B5;
        &:hover{
            border: 1px solid #909090;
        }
    ` : null}
   

    @media(max-width: 430px) {
        height: 46px !important;
        max-height: 46px !important;
        max-width: 146px;
        width: 145px;

        ${({ isGreenBG }) => isGreenBG ? css`background-color: #0DC143 !important;` : null};
    }
`;

export const LocationBlock = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #C5C6C7;
`;

export const LGButtonsWrapper = styled(FlexBox)<{isLMSTeam?: boolean, isDarkBg?: boolean}>`
    padding: 16px 0;
    max-width: 1152px;
    margin: 16px auto 0;
    gap: 24px;
    width: 100%;
    // button {
    //     height: 48px !important;
    //     min-height: 48px !important;
    //     border-radius: 3px;
    //     margin-right: 0 !important;
        
    //     font-size: 17px;
    //     line-height: 22px;
    //     font-weight: 600;
    // }
//to-do убрать лишние стили для button тега
      .button-outer, .context-button {
        min-width: ${LayoutConst.showcaseButton.l}px;
        max-width: ${LayoutConst.showcaseButton.l}px;

        // @media(max-width: ${LayoutConst.screen.l}px) {
        //     // width: ${LayoutConst.showcaseButton.m + 'px'};
        //     // max-width: ${LayoutConst.showcaseButton.m + 'px'};
        //     // min-width: ${LayoutConst.showcaseButton.m + 'px'};
        //     // width: max-content;
        //     // max-width: max-content;
        //     // min-width: max-content;
        // }

        @media(max-width: ${LayoutConst.screen.m}px) {
            width: 100%;
            max-width: 100%;
            min-width: 100%;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
          width: 100%;
          max-width: 100%;
          min-width: 100%;
        }
      }

    a:hover{
        text-decoration: none;
        color: inherit;
    }  

    .lg-switch-button{
        margin-right: 0 !important;
    }
    .longread-button {
        margin-right: 0 !important;
    }
    .longread-button-hollow-light {
       ${({ isDarkBg }) => isDarkBg && css`
          color: #fff;
          border-color: #fff;
       `}
    }
    ${({ isDarkBg }) => isDarkBg ? css`
        ${ExploreButtonFilled} {
            background-color: #ffffff !important;
            color: #151514 !important;
            border-color: #ffffff !important;
        }
    ` : null};
        
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            max-width: 888px;
            button {
                height: 40px !important;
                min-height: 40px !important;
                max-width: ${LayoutConst.bookCard.m.w + 'px'};
                min-width: ${LayoutConst.bookCard.m.w + 'px'} !important;
                width: ${LayoutConst.bookCard.m.w + 'px'};
                font-size: 15px;
            }
    }


    @media(max-width: ${LayoutConst.screen.l_12}px) {
            padding: 16px 10px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        ${ExploreButtonHollow}, ${ExploreButtonFilled}, .filled-button, .hollow-button {
            width: 100%;
            min-width: 100% !important;
            max-width: 100%;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        display: flex;
        gap: 10px;
        flex-flow: column; 
        margin: 0;
        padding: ${({isLMSTeam}) => isLMSTeam ? '0 10px' : '10px 10px 0 10px'};

        button {
            width: 100%;
            min-width: 100% !important;
            margin-bottom: 10px;
        }
    }
`;

export const LgButton = styled(RectangularButtonHollow)`
    @media(max-width: 833px) {
        max-width: 188px !important;
        width: 188px !important;
        white-space: nowrap;
        min-width: 145px !important;
    }
`;
export const Tooltip = styled(ReactTooltip)`
    font-weight: 400;
  &:before {
    z-index: -1 !important;
  }
`;

export const ButtonsBox = styled(FlexBox)`
    flex-wrap: nowrap;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    order: 2;
    place-items: end;

    @media(max-width: ${LayoutConst.screen.m}px) {
        flex-wrap: wrap;
        width: 100%;
        align-self: flex-end;
    }
        
    @media(max-width: ${LayoutConst.screen.s}px) {
        order: 3;
    }

`;

export const MobileTabsBox = styled(FlexBox).attrs<{ forceColumnDirection?: boolean }>(({ forceColumnDirection }) => ({
  className: 'mobile-tabs-box-column',
}))`
    flex-flow: column;
    width: 100%;
    order: 3;
    justify-content: space-between;
    gap: 24px;

    > div {
        margin-bottom: 0 !important;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        flex-wrap: wrap;
        width: 100%;
        align-self: flex-end;
    }
        
    @media(max-width: ${LayoutConst.screen.s}px) {
        order: 2;
    }

`;
export const MinimalTitleName = styled.div`
    width: 100%;
    margin-right: 32px;
    font-family: "Inter", sans-serif;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0;
    text-transform: uppercase;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 25px;
        line-height: 30px; /* 120% */
        letter-spacing: 0;
        margin-right: 0;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        margin-bottom: 16px;
    }

`;

export const TeamTabsWrapper = styled(FlexBox)`
  width: 100%;

  height: 28px;
  padding-right: 5px;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% + 20px);
    margin-left: -10px;
    border-bottom: 1px solid #CDCDCD;
  }
`

export const DropdownListItemTeamEdit = styled(DropdownListItem)`
  font-size: 17px;
    line-height: 22px;
    color: #8E9193;
    width: 270px;
    padding: 12px 16px;
    &:hover {
        color: ${p => p.theme.competition.langComponent.active.bg};
        background-color: ${p => p.theme.mainDropdownStyles.hoverBG};
    }
`;
export const SettingsDotsWrapper = styled.div<{ shouldDisplayEmblem?: boolean, position?: string, tooltipPos?: any }>`
    position: ${({ position }) => position || 'absolute'};
    top: 0px;
    right: 0px;
  ${({shouldDisplayEmblem, tooltipPos}) => shouldDisplayEmblem && css`
    top: ${tooltipPos.desktop.y}px;
    right: ${tooltipPos.desktop.x}px;
    z-index: 100;
    @media(max-width: ${LayoutConst.screen.m}px) {
      top: ${tooltipPos.mobile.y}px;
      right: ${tooltipPos.mobile.x}px;
    }
  `};

    @media(max-width: ${LayoutConst.screen.s-1}px) {
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 100;
    }
`;

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  width: 100% !important;
  white-space: nowrap;
`;

export const ProjectCreatePageGridInput = styled(FlexBox)`
  width: 100% !important;

  @media (max-width: ${LayoutConst.screen.md}px){
  width: 100% !important;
  }
`;

export const CustomDropdown = styled(Input.Dropdown)`
  width: 100% !important;

  .brg-input__control {
    width: 100% !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    cursor: pointer;
  }

  .brg-input__value-container {
    justify-content: center;
    margin-top: -3px;
  }

  .brg-input__placeholder {
    display: flex;
    justify-content: center;
    color: #FEFEFE !important;
    font-weight: 600;
  }

  .brg-input__placeholder:hover {
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

  .brg-input__control:hover svg {
    fill: #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__menu {
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    width: 100% !important;
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    font-weight: 600;
    padding: 8px 12px;
    background-color: transparent !important;
  }

  .brg-input__option--is-focused:not(:hover) {
    background-color: transparent !important;
  }

  .brg-input__option:hover {
    color: #151514 !important;
    background-color: rgba(254, 254, 254, 0.1) !important;
  }

  .brg-input__indicators {
    display: none;
  }
`;

export const ButtonWrapper = styled.div<{ 
  hasTabsGroup?: boolean; 
  isButtons?: boolean;
}>`
  display: flex;
  flex-direction: column;
  row-gap: ${({ hasTabsGroup, isButtons }) => 
    hasTabsGroup && isButtons ? '32px' : '0'};
  z-index: 9997;

  @media (max-width: ${LayoutConst.screen.l}px) {
    row-gap: ${({ hasTabsGroup, isButtons }) => 
      hasTabsGroup && isButtons ? '24px' : '0'};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    row-gap: ${({ hasTabsGroup, isButtons }) => 
      hasTabsGroup && isButtons ? '16px' : '0'};
  }
`;

export const MobileTabsContainer = styled(FlexBox)<{ hasLikes?: boolean }>`
  flex-direction: column;
  width: 100%;
  // margin-top: 24px !important;
  ${({ hasLikes }) => hasLikes && `
    @media (max-width: 743px) {
      margin-top: 16px !important;
    }
  `}
`;

export const SortBarWrapper = styled(FlexBox)<{ forceColumnDirection?: boolean }>`
  ${({ forceColumnDirection }) => forceColumnDirection && css`
    flex-direction: column;
    row-gap: 16px;

    .search-bar-box {
      margin-left: 0;
      justify-content: flex-start;
    }
  `}
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-wrap: wrap;
    row-gap: 16px;
  }
`;

export const LinksInnerContainer = styled(FlexBox)`
  flex-flow: column;
  justify-content: space-between;
  gap: 24px;

  .js-top-buttons-portal {
    :empty {
      display: none;
    }
  }

  @media (max-width: ${LayoutConst.screen.s-1}px) {
    width: 100%;
  }
`;import { FInter, Colors, DropdownListItem } from '@brg/ui';
import { RectangularButtonFilled, RectangularButtonHollow } from 'shared/components/buttons';
import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { ExploreButtonFilled, ExploreButtonHollow } from '../explore/styles';
import { LayoutConst } from 'core';
import ReactTooltip from 'react-tooltip';
import { Input } from '@brg/input';

const CreateBooksBtn = styled.div<{ visible: boolean }>`
    font-style: Inter;
    color: #909090;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;

`;

export const CreateBtn = styled(RectangularButtonFilled)<{ isGreenBG?: boolean, isLMS?: boolean }>`
    height: 46px !important;
    max-height: 46px !important;
    max-width: 146px;
    width: 145px;

    ${({isLMS}) => isLMS ? css`
        border: 1px solid #B6B6B5;
        &:hover{
            border: 1px solid #909090;
        }
    ` : null}
   

    @media(max-width: 430px) {
        height: 46px !important;
        max-height: 46px !important;
        max-width: 146px;
        width: 145px;

        ${({ isGreenBG }) => isGreenBG ? css`background-color: #0DC143 !important;` : null};
    }
`;

export const LocationBlock = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #C5C6C7;
`;

export const LGButtonsWrapper = styled(FlexBox)<{isLMSTeam?: boolean, isDarkBg?: boolean}>`
    padding: 16px 0;
    max-width: 1152px;
    margin: 16px auto 0;
    gap: 24px;
    width: 100%;
    // button {
    //     height: 48px !important;
    //     min-height: 48px !important;
    //     border-radius: 3px;
    //     margin-right: 0 !important;
        
    //     font-size: 17px;
    //     line-height: 22px;
    //     font-weight: 600;
    // }
//to-do убрать лишние стили для button тега
      .button-outer, .context-button {
        min-width: ${LayoutConst.showcaseButton.l}px;
        max-width: ${LayoutConst.showcaseButton.l}px;

        // @media(max-width: ${LayoutConst.screen.l}px) {
        //     // width: ${LayoutConst.showcaseButton.m + 'px'};
        //     // max-width: ${LayoutConst.showcaseButton.m + 'px'};
        //     // min-width: ${LayoutConst.showcaseButton.m + 'px'};
        //     // width: max-content;
        //     // max-width: max-content;
        //     // min-width: max-content;
        // }

        @media(max-width: ${LayoutConst.screen.m}px) {
            width: 100%;
            max-width: 100%;
            min-width: 100%;
        }

        @media (max-width: ${LayoutConst.screen.s - 1}px) {
          width: 100%;
          max-width: 100%;
          min-width: 100%;
        }
      }

    a:hover{
        text-decoration: none;
        color: inherit;
    }  

    .lg-switch-button{
        margin-right: 0 !important;
    }
    .longread-button {
        margin-right: 0 !important;
    }
    .longread-button-hollow-light {
       ${({ isDarkBg }) => isDarkBg && css`
          color: #fff;
          border-color: #fff;
       `}
    }
    ${({ isDarkBg }) => isDarkBg ? css`
        ${ExploreButtonFilled} {
            background-color: #ffffff !important;
            color: #151514 !important;
            border-color: #ffffff !important;
        }
    ` : null};
        
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            max-width: 888px;
            button {
                height: 40px !important;
                min-height: 40px !important;
                max-width: ${LayoutConst.bookCard.m.w + 'px'};
                min-width: ${LayoutConst.bookCard.m.w + 'px'} !important;
                width: ${LayoutConst.bookCard.m.w + 'px'};
                font-size: 15px;
            }
    }


    @media(max-width: ${LayoutConst.screen.l_12}px) {
            padding: 16px 10px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        ${ExploreButtonHollow}, ${ExploreButtonFilled}, .filled-button, .hollow-button {
            width: 100%;
            min-width: 100% !important;
            max-width: 100%;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        display: flex;
        gap: 10px;
        flex-flow: column; 
        margin: 0;
        padding: ${({isLMSTeam}) => isLMSTeam ? '0 10px' : '10px 10px 0 10px'};

        button {
            width: 100%;
            min-width: 100% !important;
            margin-bottom: 10px;
        }
    }
`;

export const LgButton = styled(RectangularButtonHollow)`
    @media(max-width: 833px) {
        max-width: 188px !important;
        width: 188px !important;
        white-space: nowrap;
        min-width: 145px !important;
    }
`;
export const Tooltip = styled(ReactTooltip)`
    font-weight: 400;
  &:before {
    z-index: -1 !important;
  }
`;

export const ButtonsBox = styled(FlexBox)`
    flex-wrap: nowrap;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    order: 2;
    place-items: end;

    @media(max-width: ${LayoutConst.screen.m}px) {
        flex-wrap: wrap;
        width: 100%;
        align-self: flex-end;
    }
        
    @media(max-width: ${LayoutConst.screen.s}px) {
        order: 3;
    }

`;

export const MobileTabsBox = styled(FlexBox).attrs<{ forceColumnDirection?: boolean }>(({ forceColumnDirection }) => ({
  className: 'mobile-tabs-box-column',
}))`
    flex-flow: column;
    width: 100%;
    order: 3;
    justify-content: space-between;
    gap: 24px;

    > div {
        margin-bottom: 0 !important;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        flex-wrap: wrap;
        width: 100%;
        align-self: flex-end;
    }
        
    @media(max-width: ${LayoutConst.screen.s}px) {
        order: 2;
    }

`;
export const MinimalTitleName = styled.div`
    width: 100%;
    margin-right: 32px;
    font-family: "Inter", sans-serif;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0;
    text-transform: uppercase;

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 25px;
        line-height: 30px; /* 120% */
        letter-spacing: 0;
        margin-right: 0;
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
        margin-bottom: 16px;
    }

`;

export const TeamTabsWrapper = styled(FlexBox)`
  width: 100%;

  height: 28px;
  padding-right: 5px;

  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    width: calc(100% + 20px);
    margin-left: -10px;
    border-bottom: 1px solid #CDCDCD;
  }
`

export const DropdownListItemTeamEdit = styled(DropdownListItem)`
  font-size: 17px;
    line-height: 22px;
    color: #8E9193;
    width: 270px;
    padding: 12px 16px;
    &:hover {
        color: ${p => p.theme.competition.langComponent.active.bg};
        background-color: ${p => p.theme.mainDropdownStyles.hoverBG};
    }
`;
export const SettingsDotsWrapper = styled.div<{ shouldDisplayEmblem?: boolean, position?: string, tooltipPos?: any }>`
    position: ${({ position }) => position || 'absolute'};
    top: 0px;
    right: 0px;
  ${({shouldDisplayEmblem, tooltipPos}) => shouldDisplayEmblem && css`
    top: ${tooltipPos.desktop.y}px;
    right: ${tooltipPos.desktop.x}px;
    z-index: 100;
    @media(max-width: ${LayoutConst.screen.m}px) {
      top: ${tooltipPos.mobile.y}px;
      right: ${tooltipPos.mobile.x}px;
    }
  `};

    @media(max-width: ${LayoutConst.screen.s-1}px) {
      position: absolute;
      top: 0px;
      right: 0px;
      z-index: 100;
    }
`;

export const DropdowCreateProjectnWrapper = styled(FlexBox)`
  width: 100% !important;
  white-space: nowrap;
`;

export const ProjectCreatePageGridInput = styled(FlexBox)`
  width: 100% !important;

  @media (max-width: ${LayoutConst.screen.md}px){
  width: 100% !important;
  }
`;

export const CustomDropdown = styled(Input.Dropdown)`
  width: 100% !important;

  .brg-input__control {
    width: 100% !important;
    color: #FEFEFE !important;
    background-color: #151514 !important;
    border: 1px solid #444 !important;
    box-shadow: none !important;
    cursor: pointer;
  }

  .brg-input__value-container {
    justify-content: center;
    margin-top: -3px;
  }

  .brg-input__placeholder {
    display: flex;
    justify-content: center;
    color: #FEFEFE !important;
    font-weight: 600;
  }

  .brg-input__placeholder:hover {
    color: #FEFEFE !important;
  }
  .brg-input__control:hover .brg-input__placeholder {
    color: #FEFEFE !important;
  }

  .brg-input__control:hover svg {
    fill: #FEFEFE !important;
    color: #FEFEFE !important;
  }

  .brg-input__menu {
    border-radius: 3px;
    margin-top: 8px;
  }

  .brg-input__menu-list {
    width: 100% !important;
    padding: 0;
  }

  .brg-input__option {
    color: #ddd !important;
    font-weight: 600;
    padding: 8px 12px;
    background-color: transparent !important;
  }

  .brg-input__option--is-focused:not(:hover) {
    background-color: transparent !important;
  }

  .brg-input__option:hover {
    color: #151514 !important;
    background-color: rgba(254, 254, 254, 0.1) !important;
  }

  .brg-input__indicators {
    display: none;
  }
`;

export const ButtonWrapper = styled.div<{ 
  hasTabsGroup?: boolean; 
  isButtons?: boolean;
}>`
  display: flex;
  flex-direction: column;
  row-gap: ${({ hasTabsGroup, isButtons }) => 
    hasTabsGroup && isButtons ? '32px' : '0'};
  z-index: 9997;

  @media (max-width: ${LayoutConst.screen.l}px) {
    row-gap: ${({ hasTabsGroup, isButtons }) => 
      hasTabsGroup && isButtons ? '24px' : '0'};
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    row-gap: ${({ hasTabsGroup, isButtons }) => 
      hasTabsGroup && isButtons ? '16px' : '0'};
  }
`;

export const MobileTabsContainer = styled(FlexBox)<{ hasLikes?: boolean }>`
  flex-direction: column;
  width: 100%;
  // margin-top: 24px !important;
  ${({ hasLikes }) => hasLikes && `
    @media (max-width: 743px) {
      margin-top: 16px !important;
    }
  `}
`;

export const SortBarWrapper = styled(FlexBox)<{ forceColumnDirection?: boolean }>`
  ${({ forceColumnDirection }) => forceColumnDirection && css`
    flex-direction: column;
    row-gap: 16px;

    .search-bar-box {
      margin-left: 0;
      justify-content: flex-start;
    }
  `}
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-wrap: wrap;
    row-gap: 16px;
  }
`;

export const LinksInnerContainer = styled(FlexBox)`
  flex-flow: column;
  justify-content: space-between;
  gap: 24px;

  .js-top-buttons-portal {
    :empty {
      display: none;
    }
  }

  @media (max-width: ${LayoutConst.screen.s-1}px) {
    width: 100%;
  }
`;